import { addBrokerSuccessModalProps, defaultModalProps } from 'modal-tpyes'
import {
  useMediaQuery,
  useTheme,
  SwipeableDrawer,
  Dialog,
  makeStyles,
  Typography,
  Box,
} from '@material-ui/core'
import React , { useState, useEffect, Fragment } from 'react'
// import { useSelector, StateProps} from 'react-redux'
import CloseIcon from "@material-ui/icons/Close";
import SelectBrokerSection from './SelectBrokerSection'
import SigninBrokerSection from './SigninBrokerSection'
// @ts-ignore
// import { CREATE_BROKER_ACCOUNT, useMutation } from 'src/graphql'
import { createSubscriptionResponse } from 'subsciption-types'
import { useDispatch } from 'react-redux'
import { setDialog } from 'src/actions'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { addInvestorAccountByLogin } from 'src/graphql/mutations/investor'
import { useMutation } from '@apollo/react-hooks'
import { zeroPad } from 'src/utils/utils';

interface stylesProp {
  useMobileUI:boolean
}

function TabPanel(props:any) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </Box>
  );
}


const useStyles = makeStyles((theme)=>({
  root: (props:stylesProp) => ({
    borderRadius: props.useMobileUI ? "16px 16px 16px 16px" : "16px 16px 0 0",
    background: theme.palette.background.default,
    padding: "8px",
  }),
  closeIcon : {
    position: "absolute",
    cursor: "pointer",
    color: theme.palette.primary.main,
    top: theme.spacing(2),
    left: theme.spacing(3),
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}))

const AddBrokerModal:React.FC<defaultModalProps> = ({
  open,
  handleBack,
  handleClose,
}) => {

  const theme = useTheme();
  // const account = useSelector((state:StateProps)=>state.account)
  const dispatch = useDispatch();
  const useMobileUI = useMediaQuery(theme.breakpoints.up("sm"));
  const styleProps = { useMobileUI: useMobileUI };
  const classes = useStyles(styleProps);
  // const [selectedBroker,setSelectedBroker] = useState("")
  const [addBrokerState,setAddBrokerState] = useState(0);
  const [signinUsername,setSigninUsername] = useState("8");
  const [singinPassword,setSigninPassword] = useState("abcd1234")
  const brokerAvaibles = ["sandbox"];
  const [addInvestorAccount] = useMutation(addInvestorAccountByLogin)
  // const [newBrokerAccount] = useMutation<createSubscriptionResponse>(CREATE_BROKER_ACCOUNT);

  // ------------------------ default function ---------------------------
  const onClose = () => {
    handleClose()
    setAddBrokerState(0)
  }

  const ModalProps = {
    paper: classes.root,
  };

  useEffect(()=>{
    if (open) {
      setAddBrokerState(0)
    }
  },[open])

  const openModal = (name:string,state:boolean,props:addBrokerSuccessModalProps) => {
    dispatch(setDialog(name,state,props))
  }

  const signinBrokerAccount = () =>
  new Promise<createSubscriptionResponse>( async (resolve, reject) => {
    try {
    let signinParams = {
      username: signinUsername,
      password: singinPassword,
    };
    const { data } = await addInvestorAccount({ variables: signinParams })
    resolve(data)
    } catch (err) {
      reject(err)
    }
  });

  // --------------------- select broker section -------------------------
  const handleSelectBroker = (broker:string) => {
    setAddBrokerState(1)
    // setSelectedBroker(broker)
  }

  const onSubmit = async() => {
    try {
      await signinBrokerAccount();
      let props : addBrokerSuccessModalProps = {
        isAddSuccess : true,
        addedBrokerAccount : [`FT${zeroPad(parseInt(signinUsername),9)}E`,`FT${zeroPad(parseInt(signinUsername),9)}D`],
        brokerUsername : signinUsername,
        message : "Add Investor Account Success",
        messageTh : "เพิ่ม Investor Account สำเร็จ"
      }
      openModal('addBrokerSuccessModal',true,props)

    } catch(err) {
      let props : any = {
        isAddSuccess : false,
        message : err.message,
        messageTh : err.messageTh
      }
      openModal('addBrokerSuccessModal',true,props)
      setAddBrokerState(1)
    }
  }

  const handleSigninData = (type:string,value:string) => {
    if (type === 'username') setSigninUsername(value)
    if (type === 'password') setSigninPassword(value)
  }

  const Header = () => (
    <Fragment>
      {addBrokerState===0&&
      <CloseIcon
        className={classes.closeIcon}
        onClick={handleClose}
      />}
      {addBrokerState===1&&
        <ArrowBackIosIcon
        className={classes.closeIcon}
        onClick={()=>setAddBrokerState(0)}
        />
      }
      <Box mt={1}/>
      <Typography
        variant="subtitle1"
        color="textPrimary"
        style={{ textAlign: "center" }}
      >
      เพิ่มบัญชีหุ้น (เลือก Broker)
      </Typography>
    </Fragment>
  )

  const Loading = () => (
    <div>
    <p>Loading...</p>
    </div>
  )

  const content = () => (
    <Fragment>
      <TabPanel value={addBrokerState} index={0} dir={theme.direction}>
        <SelectBrokerSection brokers={brokerAvaibles} handleSelectBroker={handleSelectBroker}/>
      </TabPanel>
      <TabPanel value={addBrokerState} index={1} dir={theme.direction}>
        <SigninBrokerSection handleSigninData={handleSigninData} onSubmit={onSubmit} signinUsername={signinUsername} signinPasssword={singinPassword}/>
      </TabPanel>
      <TabPanel value={addBrokerState} index={2} dir={theme.direction}>
        <Loading/>
      </TabPanel>
    </Fragment>
  )


  return (
    useMobileUI ? (
      <Dialog open={open||false}  keepMounted onClose={onClose} fullWidth classes={ModalProps} maxWidth="xs">
        <Header/>
        {content()}
      </Dialog>
     ) :
    (
      <SwipeableDrawer open={open||false} onOpen={()=>{}} keepMounted onClose={onClose} classes={ModalProps} anchor={"bottom"}>
        <Header/>
        {content()}
      </SwipeableDrawer>
    )
  )
}

export default AddBrokerModal